import { K8sProvider } from '@cast/shared-types';

import { DEFAULT_NODE_JOB_CONFIG } from './constants';
import { NodeJobConfig } from './types';

export const getNodeJobConfigDefaultValue = (
  providerType?: K8sProvider
): NodeJobConfig => {
  let jobConfig = DEFAULT_NODE_JOB_CONFIG;

  switch (providerType) {
    case 'eks':
      jobConfig = {
        nodeConfig: {
          instanceType: 'm5.xlarge',
        },
      };
      break;
    case 'aks':
      jobConfig = {
        nodeConfig: {
          instanceType: 'Standard_D4s_v6',
        },
      };
      break;
    case 'gke':
      jobConfig = {
        nodeConfig: {
          instanceType: 'n4-standard-4',
        },
      };
      break;
    default:
      break;
  }

  return jobConfig;
};
